var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import Component from "vue-class-component";
import { Dependencies } from "~/core/decorator";
import { CaseApplyOperateService } from "~/services/domain-service/case-apply-operate.service";
import { Emit, Prop } from "vue-property-decorator";
import { SortService } from "~/utils/sort.service";
import { PageService } from "~/utils/page.service";
import { UserService } from "~/services/manage-service/user.service";
import DataBox from "~/components/common/data-box.vue";
import { Approve_Type } from "~/config/enum.business";
var ApplicationDataRefuse = /** @class */ (function (_super) {
    __extends(ApplicationDataRefuse, _super);
    function ApplicationDataRefuse() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.nowNode = null;
        _this.caseList = []; // 案件数组
        _this.applicationDataSet = [];
        _this.applicationselectionList = [];
        _this.SearchModel = {};
        return _this;
    }
    ApplicationDataRefuse.prototype.refreshList = function () { };
    ApplicationDataRefuse.prototype.close = function () { };
    /**
     * 刷新用户列表
     */
    ApplicationDataRefuse.prototype.refreshData = function () {
        var _this = this;
        this.SearchModel = Object.assign(this.applicationModel);
        this.SearchModel.approvalResult = "APPROVED_REJECT";
        this.SearchModel.applyType = "CHECK_MATERIAL_APPLY"; //协调查询的类型 CHECK_MATERIAL_APPLY 申请资料
        this.SearchModel.approvalStatus = Approve_Type["complete"]; //完成审核
        this.caseApplyOperateService.caseApprovalSearch(this.SearchModel, this.pageService, this.sortService).subscribe(function (data) {
            data = data.filter(function (v) { return v.approvedResult == "APPROVED_REJECT"; });
            _this.applicationDataSet = data;
        }, function (_a) {
            var msg = _a.msg;
        });
    };
    __decorate([
        Dependencies(SortService)
    ], ApplicationDataRefuse.prototype, "sortService", void 0);
    __decorate([
        Dependencies(PageService)
    ], ApplicationDataRefuse.prototype, "pageService", void 0);
    __decorate([
        Dependencies(UserService)
    ], ApplicationDataRefuse.prototype, "userService", void 0);
    __decorate([
        Dependencies(CaseApplyOperateService)
    ], ApplicationDataRefuse.prototype, "caseApplyOperateService", void 0);
    __decorate([
        Emit("refreshList")
    ], ApplicationDataRefuse.prototype, "refreshList", null);
    __decorate([
        Emit("close")
    ], ApplicationDataRefuse.prototype, "close", null);
    __decorate([
        Prop()
    ], ApplicationDataRefuse.prototype, "applicationModel", void 0);
    ApplicationDataRefuse = __decorate([
        Component({
            components: {
                DataBox: DataBox,
            },
        })
    ], ApplicationDataRefuse);
    return ApplicationDataRefuse;
}(Vue));
export default ApplicationDataRefuse;
